import { getLocale } from '@hub/libs/constants';
import { getCanonical } from '@hub/libs/i18n.helper';
import { IGUS_REWRITE } from '@hub/libs/redirect.helper';
import { useRouter } from 'next/router';
import { useMemo } from 'react';

export const useBaseUrl = () => {
  const { asPath, locale } = useRouter();

  return useMemo(() => IGUS_REWRITE(getCanonical(asPath, locale), getLocale({ locale })), [asPath, locale]);
};
